var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getApiClient } from "../../services/AxiosClients";
import FetchService from "./Shared/FetchService";
const BASE_URL = "/aviso/course";
export default class CourseService {
    static getCourses(search, pageSize = 50) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("/courses/search/findByCodeOrNameLike", {
                params: { search, size: pageSize },
            });
            return response.data._embedded.courses;
        });
    }
    static getActiveCourses(search, pageSize = 50) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield getApiClient().get("/courses/search/findByCodeOrNameLikeAndActive", {
                params: { search, size: pageSize },
            });
            return data._embedded.courses;
        });
    }
    static findByIds(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("/courses/search/findByIdIn", {
                params: { ids: ids.join(",") },
            });
            return response.data._embedded.courses;
        });
    }
    static search(search = {}, options = {}) {
        return FetchService.getPagedResponse(BASE_URL + "/search", {
            ids: search.ids,
            codes: search.codes,
            query: search.query,
            active: search.active,
            creditsMin: search.creditsMin,
            creditsMax: search.creditsMax,
            hasActiveCourseSections: search.hasActiveCourseSections,
            max: options.max,
            offset: options.offset,
            sort: options.sort,
            order: options.order,
        });
    }
}
